"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./style.less");

var _hash = require("../../utils/hash");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var COLORS = ['yellow', 'blue', 'green'];

var CustomTag = function CustomTag(_ref) {
  var name = _ref.name,
      _ref$onDelete = _ref.onDelete,
      onDelete = _ref$onDelete === void 0 ? null : _ref$onDelete,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  var colorClass = (0, _react.useMemo)(function () {
    return COLORS[(0, _hash.stringToHash)(name, COLORS.length)];
  }, [name]);
  var handleClose = (0, _react.useCallback)(function () {
    return onDelete(name);
  }, [onDelete, name]);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "\n        CustomTag\n        ".concat(className || '', "\n        ").concat(!onDelete ? '' : 'CustomTag__deletable', "\n        CustomTag__color_").concat(colorClass, "\n      ")
  }, name, !onDelete ? null : /*#__PURE__*/_react.default.createElement("button", {
    className: "CustomTag__deletebutton",
    onClick: handleClose
  }, "\xD7"));
};

var _default = CustomTag;
exports.default = _default;